// extracted by mini-css-extract-plugin
module.exports = {"taxonomy":"taxonomy--3ZIQ_","taxonomy_open":"taxonomy_open--1jQzp","taxonomy__selected":"taxonomy__selected--Fqzb6","taxonomy__dropdown":"taxonomy__dropdown--2SSCE","taxonomy__search":"taxonomy__search--32kx4","taxonomy__item":"taxonomy__item--3qB7k","taxonomy__grouping":"taxonomy__grouping--1K7Ux","taxonomy__collapsable":"taxonomy__collapsable--3gQxI"};
    if(module.hot) {
      // 1637785525812
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  